/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import MSCombidy2D from './mscombidy2d';
import { _setAxisScale, _resetViewPortConfig, configurer } from './scrollcolumn2d';
import { scrollTo } from '../_internal/misc/scroll-apis';
/**
 * Creates ScrollCombiDy2D class
 */
class ScrollCombiDy2D extends MSCombidy2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'ScrollCombiDy2D';
  }

  /**
   * Function to state if inputOptions are to be used for this charts
   * @return {Array} value
   */
  static includeInputOptions () {
    return ['SwipeGesture'];
  }

  /**
   * Constructor fn of class ScrollCombiDy2D
   */
  constructor () {
    super();
    this.canvasborderthickness = 1;
    this.avgScrollPointWidth = 40;
    this.hasScroll = true;
    this.eiMethods = {
      'scrollTo': scrollTo
    };
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'ScrollCombiDy2D';
  }
  /**
   * Sets default configuration
   * @memberof ScrollCombiDy2D
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Scrollable Dual Y-Axis Combination Chart';
    config.defaultDatasetType = 'column';
    config.showzeroplaneontop = 0;
  }

  /**
   * function to create component and configure and also configure the chart
   * It creates components which are depend on data and configure them and also configure chart
   * It calls helper function namely, configure
   * @param  {Object} dataObj contains json data of the chart
   */
  configureAttributes (dataObj) {
    super.configureAttributes(dataObj);
    configurer.call(this, dataObj);
  }

  /**
   * Sets xAxis scale visible region
   */
  _setAxisScale () {
    _setAxisScale.call(this);
  }

  /**
   * Reset view port
   */
  _resetViewPortConfig () {
    _resetViewPortConfig.call(this);
  }
}
export default ScrollCombiDy2D;
